import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API, formatApiError } from "../AuthContext";
import AppHeader from "../components/AppHeader";
import SiteFooter from "../components/SiteFooter";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError(null);
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail, "Could not send reset email."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page" data-testid="forgot-page">
      <div className="grain-bg" />
      <div className="container-narrow">
        <AppHeader />
        <div className="fade-in" style={{ maxWidth: 420, margin: "0 auto" }}>
          <div className="eyebrow" style={{ marginBottom: 16 }}>Reset</div>
          <h1 className="display">Forgot your password.</h1>

          {sent ? (
            <div data-testid="forgot-sent" className="serif-italic" style={{ fontSize: 17, color: "var(--accent)", lineHeight: 1.7 }}>
              Check your inbox. If an account exists for <strong>{email}</strong>, a reset link is on its way. It's valid for one hour.
              <div style={{ marginTop: 28 }}>
                <Link to="/login" className="btn-underline" data-testid="forgot-back-to-login">Back to sign in</Link>
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="form-stack" data-testid="forgot-form">
              <p className="serif-italic" style={{ fontSize: 17, color: "var(--accent)", lineHeight: 1.6, marginBottom: 16 }}>
                Enter your email. We'll send you a link to set a new password.
              </p>
              <div>
                <label className="field-label" htmlFor="email">Email</label>
                <input
                  id="email" type="email" required
                  value={email} onChange={(e) => setEmail(e.target.value)}
                  className="input-line" placeholder="you@example.com"
                  data-testid="forgot-email-input"
                />
              </div>
              {error && <div className="error-msg" data-testid="forgot-error">{error}</div>}
              <div style={{ paddingTop: 8 }}>
                <button type="submit" className="btn-underline" disabled={loading} data-testid="forgot-submit-btn">
                  {loading ? "Sending…" : "Send reset link →"}
                </button>
              </div>
              <div style={{ paddingTop: 16 }}>
                <Link to="/login" className="nav-link" data-testid="forgot-cancel">← Back to sign in</Link>
              </div>
            </form>
          )}
        </div>
        <SiteFooter />
      </div>
    </div>
  );
}
